import { PayloadAction } from '@reduxjs/toolkit';
import { setUserId } from '../slices/user';
import { listenerMiddleware } from '../store';
import { api } from '../services/api';

const startUserListeners = () => {
  listenerMiddleware.startListening({
    actionCreator: setUserId,
    effect: async (action: PayloadAction<number>, { dispatch }) => {
      const userId = action.payload;

      // Fetch list of subscription Ids
      dispatch(api.endpoints.getSubscriptionSummariesByUserId.initiate(userId));

      // Fetch list of bot ids (if master or dev)
      // @TODO, We want to set more than just userId
      // So we can check on master of dev, not the userId
      if (userId === 1 || userId === 2) {
        dispatch(api.endpoints.getBotIds.initiate(undefined));
      }
    },
  });
};

export default startUserListeners;
